import { createSlice } from "@reduxjs/toolkit";
import { getAxios } from "./axiosActions";
import _ from 'lodash'
import { getPromptFromEnv, getPromptsCache } from "./prompts";

export const initialState = {
  loadingLocation: false,
  loadingInternalLocations: false,
  hasErrors: false,
  locations: [],
  locationTypes: [],
  subTopics: [],
  brands: [],
  regions: [],
  facts: [],
  users: [],
  locationUsers: [],
  internalLocations: [],
  prompts:[],
  brandVoice:[],
  promptTemplates:[],
  issueList:[],
  sourceTypes:[],
  responsePhrases:[],
  responderSettings:[],
  selectedThen:{},
  promptTypes:[]
};
const updateEntityData = (state, data, entityName) => {
  if (!data) return state;
  switch (entityName) {

      case 'prompts':
          return _.unionBy(data, state, 'promptId');
     
      default: return state;
  }
};
const deleteEntityData = (state, data, entityName) => {
  if (!data) return state;
  switch (entityName) {
    case 'prompts':
      const filteredData = _.filter(state, it => _.toLower(it.promptId) !== _.toLower(data));
      return filteredData;
    default:
      return state;
  }
};

const locationsSlice = createSlice({
  name: "masterData",
  initialState,
  reducers: {
    getLocations: (state) => {
      state.loadingLocation = true;
    },
    getLocationsSuccess: (state, { payload }) => {
      state.locations = payload?.locations ?? [];
      state.locationTypes = payload?.locationTypes ?? [];
      state.subTopics = payload?.subTopics ?? [];
      state.regions = payload?.regions ?? [];
      state.brands = payload?.brands ?? [];
      state.facts = payload?.facts ?? [];
      state.users = payload?.users ?? [];
      state.locationUsers = payload?.locationUsers ?? [];
      state.prompts=payload?.prompts??[]
      state.promptTypes=payload?.promptTypes??[]
      state.brandVoice=payload?.brandVoices??[]
      state.promptTemplates=payload?.promptTemplates??[];
      state.issueList=payload?.issueList??[];
      state.sourceTypes=payload?.sourceTypes??[];
      state.responsePhrases=payload?.responsePhrases??[]
      state.responderSettings=payload?.responderSettings??[]
      state.loadingLocation = false;
      state.hasErrors = false;
    },
    getLocationsFailure: (state) => {
      state.loadingLocation = false;
      state.hasErrors = true;
    },
    getInternalLocations: (state) => {
      state.loadingInternalLocations = true;
    },
    getInternalLocationsSuccess: (state, { payload }) => {
      state.internalLocations = payload;
      state.loadingInternalLocations = false;
      state.hasErrors = false;
    },
    getInternalLocationsFailure: (state) => {
      state.loadingInternalLocations = false;
      state.hasErrors = true;
    },
    getMasterDataUpdateSuccess: (state, { payload }) => {
      if (payload.key) {
        let data = [];
        if(payload?.data?.length > 0){
          data = [...payload.data]
        }
        else{
          data = [payload.data]
        }
        state[payload.key] = updateEntityData(state[payload.key] ?? [], data, payload.key);
      }
    },
    promptUpdate:(state,{payload})=>{
      const currState=state.prompts
      const selectedPrompt=_.find(currState,{promptId:payload?.promptId})
      if(selectedPrompt&&!_.isEmpty(selectedPrompt)){
      selectedPrompt['isProcessPrompt']=payload?.isProcessPrompt?true:false
      const filteredData=_.filter(currState,a=>a?.promptId!==payload?.promptId)
      state.prompts=[...filteredData,selectedPrompt]
    }
    },
    masterDataDelete:(state,{payload})=>{
      if(payload.key){
        
        state[payload.key]=deleteEntityData(state[payload.key] ?? [], payload.data, payload.key)
      }
    },

    setSelectedThen:(state,{payload})=>{
      state.selectedThen=payload
    }
  },
});

export const {
  getLocations,
  getLocationsSuccess,
  getLocationsFailure,
  getInternalLocations,
  getInternalLocationsSuccess,
  getInternalLocationsFailure,
  getMasterDataUpdateSuccess,
  masterDataDelete,
  promptUpdate,
  setSelectedThen
} = locationsSlice.actions;
export const locationsSelector = (state) => state.masterData;
export default locationsSlice.reducer;
export function fetchLocations(companyId,env) {
  return async (dispatch) => {
    dispatch(getLocations());
    try {
      const params = { callTime: new Date() };
      const response = await getAxios(
        "api/Master/GetMasterData?companyId=" + companyId,
        { params: params }
      );
      if (response) {
        dispatch(getLocationsSuccess(response));
        if(response.prompts){
          dispatch(getPromptsCache({key:env??'dev',data:response.prompts??[]}))
        }
      } else {
        dispatch(getLocationsFailure());
      }
    } catch (error) {
      dispatch(getLocationsFailure());
    }
  };
}

export function fetchInternalLocations(companyId) {
  return async (dispatch) => {
    dispatch(getInternalLocations());
    try {
      const params = { callTime: new Date() };
      let response;
      if (companyId) {
        response = await getAxios(
          "api/Location/GetInternalLocations?companyId=" + companyId,
          { params: params }
        );
        if (response) {
          dispatch(getInternalLocationsSuccess(response));
        } else {
          dispatch(getInternalLocationsFailure());
        }
      }
    } catch (error) {
      dispatch(getInternalLocationsFailure());
    }
  };
}
